let idCounter = 0;

export function UniqueId(): string {
  const id: number = ++idCounter;
  return `${id}`;
}
